import { StagesIndicator } from './StagesIndicator';

export default StagesIndicator;